module.exports = "<template>\r\n  <require from=\"./curtain-controller-chart.scss\"></require>\r\n \r\n</template>";